export function isFacetFieldDef(channelDef) {
  return !!channelDef && !!channelDef['header'];
}